export const contactsData = {
    email: 'amar.mau96@gmail.com',
    phone: '+919699262448',
    address: '179, Arazibag, Azamgarh, Uttar Pradesh - 276001',

    sheetAPI: ''
}